/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CalendarDataPoint } from "./CalendarDataPoint";
import {
  CalendarDataPointFromJSON,
  CalendarDataPointFromJSONTyped,
  CalendarDataPointToJSON,
  CalendarDataPointToJSONTyped,
} from "./CalendarDataPoint";

/**
 *
 * @export
 * @interface CalendarDataResponse
 */
export interface CalendarDataResponse {
  /**
   *
   * @type {LocalDate}
   * @memberof CalendarDataResponse
   */
  earliestDate: LocalDate;
  /**
   *
   * @type {Array<CalendarDataPoint>}
   * @memberof CalendarDataResponse
   */
  data: Array<CalendarDataPoint>;
}

/**
 * Check if a given object implements the CalendarDataResponse interface.
 */
export function instanceOfCalendarDataResponse(
  value: object,
): value is CalendarDataResponse {
  if (!("earliestDate" in value) || value["earliestDate"] === undefined)
    return false;
  if (!("data" in value) || value["data"] === undefined) return false;
  return true;
}

export function CalendarDataResponseFromJSON(json: any): CalendarDataResponse {
  return CalendarDataResponseFromJSONTyped(json, false);
}

export function CalendarDataResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CalendarDataResponse {
  if (json == null) {
    return json;
  }
  return {
    earliestDate: json["earliestDate"],
    data: (json["data"] as Array<any>).map(CalendarDataPointFromJSON),
  };
}

export function CalendarDataResponseToJSON(json: any): CalendarDataResponse {
  return CalendarDataResponseToJSONTyped(json, false);
}

export function CalendarDataResponseToJSONTyped(
  value?: CalendarDataResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    earliestDate: value["earliestDate"],
    data: (value["data"] as Array<any>).map(CalendarDataPointToJSON),
  };
}
